<template>
    <div>
        <div style="display: flex;justify-content: center;">

            <div style="width: 1200px;">
                <Bread :breads="breads" defaultType="2"></Bread>
                <img src="/static/img/zhuhai/填报指南title.svg" alt="">

                <div class="about-content-box" >
                    <el-row>
                        <el-col :span="24" style="padding-left: 20px;" >
                            <div style="min-height: 600px;" v-html="content">

                            </div>
                        </el-col>
                    </el-row>

                </div>

            </div>


        </div>
    </div>
</template>

<script setup >

import {ref, toRefs, reactive, getCurrentInstance, onMounted} from 'vue'
import { Search,RefreshRight } from '@element-plus/icons-vue'
import Bread from "@/components/common/Bread.vue";
import {useRoute} from "vue-router";


const {proxy} = getCurrentInstance();

const breads = ref([
    {text:'首页', path:'/zhaoqing/index'},
    {text:'填报指南'}
])

const content = ref('');


const getContent = () => {

    proxy.$http.post('/core/cms/a/articleContent/info', {id:'WEB_ZHAOQING_FILLING_GUIDE'}).then(res => {
        if (res.data.state == 0) {
            if(res.data.state === 0){
                content.value = res.data.result.content;
            }
        }
    }).catch(err => {
    });
}



const route = useRoute();
onMounted(()=>{
    getContent();
});


</script>

<style lang="less" scoped>


.text-center{
    text-align: center;
}



.about-content-box{
    background: linear-gradient(180deg, #FFFFFF 0%, #F6F9FF 100%);
    background-size: 100% 600px;
    background-repeat: no-repeat;
    padding: 15px 20px;
    border-radius: 10px;
    margin-top: 15px;
}





.scrollbar-demo-item{

    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    margin: 10px;
    text-align: center;
    border-radius: 4px;
    background: var(--el-color-primary-light-9);
    color: var(--el-color-primary);
}
.instrument-title{
    background-color: #007EEC;
    color: white;
    height: 40px;
    font-size: 18px;
    display:flex;
    align-items: flex-end;
    padding: 5px 15px;
}
.about-type{
    margin-top: 10px;
    height: 51px;
    background: linear-gradient(124deg, #F3F9FF 14%, #F4F6FF 55%);
    text-align: center;
    line-height: 51px;
    border-radius: 5px;
}
.about-type.active{
    background: #1B66FC;
    color: white;
}
.platform-info-name{
    font-family: 思源黑体;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0px;
    color: #1B66FC;
}
.platform-info-field{
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    color: rgba(0, 0, 0, 0.85);
    margin-right: 27px;
}
.platform-count{
    font-family: 思源黑体;
    font-size: 20px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0px;
}
.platform-info-desc{
    color: #A5A5A5;
    font-family: 思源黑体;
    font-size: 12px;
    font-weight: normal;
    line-height: 14px;
    letter-spacing: 0px;
}
.platform-info-box{
    height: 100px;
    overflow: hidden; /* 1. 隐藏超出内容 */
    text-overflow: ellipsis; /* 2. 超出部分显示省略号 */
    display: -webkit-box; /* 3. 将元素转为弹性伸缩盒子模型 */
    -webkit-line-clamp: 4; /* 4. 关键属性：限制显示的行数，比如2行就写2，3行写3 */
    -webkit-box-orient: vertical; /* 5. 关键属性：设置伸缩盒子的子元素排列方式为垂直 */
}
.about-type:hover{
    cursor: pointer;
}
</style>

